export default __webpack_public_path__ + "static/media/test.8e50c906.gif";